import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export function CompositionTitle({
  note,
  index,
}: {
  note: string | null;
  index: number;
}) {
  const { t } = useTranslation();

  return (
    <Text
      bg="whiteAlpha.200"
      py={3}
      px={1}
      sx={{ writingMode: 'sideways-lr' }}
      borderRadius="md"
      _light={{ bg: 'blackAlpha.200' }}
    >
      {note ? note : t('composition.compositionNr', { nr: index })}
    </Text>
  );
}
